export default __webpack_public_path__ + "static/media/797.5c70d1ef.gif";